import type { InputFieldProps, InputProps } from './InputExtended';
import InputExtended, { InputExtendedField, Prefix, Suffix } from './InputExtended';

export default InputExtended;

export { InputExtendedField, Prefix, Suffix, InputProps, InputFieldProps };
